import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons'; // FontAwesomeからアイコンをインポート
import { toYYYYMMDD, formatDateWeekday } from '../utils/commonUtils';

const DailyReportItem = ({ report, secCode }) => {
    const [expanded, setExpanded] = useState(false); // 初期状態は折りたたみ
    const maxLength = 80;

    // コンテンツが60文字以上の場合に省略表示
    const isLongContent = report.contents.length > maxLength;
    const displayedContent = expanded ? report.contents : report.contents.substring(0, maxLength);

    return (
        <li className='daily-report'>
            <a href={`daily-report/${secCode}/${toYYYYMMDD(report.date)}`}>
                <span className="daily-report-list-company">
                    <span className="company-name">{report['date'] ? formatDateWeekday(report['date']) : ""}</span>
                </span>
            </a>
            <div className="contents">
              <a href={`daily-report/${secCode}/${toYYYYMMDD(report.date)}`}>
                      {displayedContent}
                      {isLongContent && !expanded && '...'} {/* 60文字以上の場合、省略を表示 */}
              </a>
              {isLongContent && (
                  <FontAwesomeIcon
                      icon={expanded ? faMinus : faPlus}  // 展開済みかでアイコンを切り替え
                      onClick={() => setExpanded(!expanded)} // クリックで展開・折りたたみを切り替え
                      className="note-plus-minus-icon" 
                  />
              )}
            </div>
        </li>
    );
};

const DailyReportListByCompany = ({ secCode, companyName, dailyReports }) => {
    return (
        <div className='daily-report-container'>
            <div className='daily-report-date'>{companyName} ({secCode})</div>
            <ul className='ul-daily-report'>
                {dailyReports.map((report) => (
                    <DailyReportItem key={report.date} report={report} secCode={secCode} />
                ))}
            </ul>
        </div>
    );
};


export default DailyReportListByCompany;
